import React, { useState } from 'react';
import {
  Box,
  Button,
  Chip,
  InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Link } from 'react-router-dom';
import Sidebar from '../Navigation/Sidebar/Sidebar';
import { ArrowBack } from '@mui/icons-material';
import InactivateEmailDialog from './popup';
const days = ['All Day', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const statuses = ['All', 'Active', 'Inactive'];

const AgentRoster = ({ rawAgentData,update_roster,open,setOpen }) => {
  console.log("agentData", rawAgentData);
  const [search, setSearch] = useState('');
  const [dayFilter, setDayFilter] = useState('All Day');
  const [statusFilter, setStatusFilter] = useState('All'); // ✅ new state

const [mylist,setMylist]=useState(null)
  // Flatten nested data
  const flattenedData = rawAgentData?.flatMap((agent) =>
    agent.agent_Time.map((timeSlot) => ({
      email: agent.agent_Email,
      day: timeSlot.day,
      time: `${timeSlot.start_Time} - ${timeSlot.end_Time}`,
      status: timeSlot.isActive ? 'Active' : 'Inactive',
    }))
  );

const handle_update_roster=(e,entry)=>{
  setMylist(entry)
  setOpen(true)


}

const handleClose=(e)=>{
  setOpen(false)
}

  // Apply filters
  const filteredData = flattenedData?.filter((entry) => {
    const matchesSearch = entry.email.toLowerCase().includes(search.toLowerCase());
    const matchesDay = dayFilter === 'All Day' || entry.day === dayFilter;
    const matchesStatus = statusFilter === 'All' || entry.status === statusFilter;
    return matchesSearch && matchesDay && matchesStatus;
  });

  return (
    <>
   {open&&<InactivateEmailDialog onConfirm={update_roster} email={"email"}  update_roster={update_roster} mylist={mylist} handleClose={handleClose}/>}
      <div className="main-div">
        
        <div>
          <Sidebar />
        </div>
        <Box p={4}>
       <Typography variant="h6" fontWeight="bold" mb={2} display="flex" alignItems="center">
  <Link to="/">
    <ArrowBack sx={{ color: 'black', mr: 1 }} />
  </Link>
  Customer Support Agent Rooster
</Typography>


          {/* Top Bar */}
          <Box display="flex" justifyContent="space-between" mb={2} flexWrap="wrap" gap={2}>
            <TextField
              placeholder="Search by agent email"
              variant="outlined"
              size="small"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: 250 }}
            />

            {/* Day Filter */}
            <Select
              size="small"
              value={dayFilter}
              onChange={(e) => setDayFilter(e.target.value)}
            >
              {days.map((day) => (
                <MenuItem key={day} value={day}>
                  {day}
                </MenuItem>
              ))}
            </Select>

            {/* ✅ Status Filter */}
            <Select
              size="small"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              {statuses.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>

            <Link to="/create_cst_rooster">
              <Button variant="contained" color="success">
                + Create
              </Button>
            </Link>
          </Box>

          {/* Table */}
          <Box borderRadius={2} boxShadow={2} style={{ height: "70vh", overflow: "scroll" }}>
            <Table>
              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell style={{ textAlign: 'center' }}>S.No.</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>Email ID</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>Day</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>Time Slot</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData?.map((entry, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{entry.email}</TableCell>
                    <TableCell>{entry.day}</TableCell>
                    <TableCell>{entry.time}</TableCell>
                    <TableCell style={{cursor:"pointer"}} onClick={(e)=>{handle_update_roster(e,entry)}}>
                      <Chip
                        label={entry.status}
                        color={entry.status === 'Active' ? 'success' : 'error'}
                        variant="outlined"
                      
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default AgentRoster;
